import React from 'react';

// Component to safely render HTML content from the editor
const HtmlContent = ({ html, className }) => {
  return (
    <div 
      className={`html-content ${className || ''}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default HtmlContent;
